module.exports = __webpack_public_path__ + "img/52002772_L.b859904a.png";